export const EnvSelector = {
	env: 'prod-global'
};